import React from "react";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_LEGAL_ENTITY } from "../../../service/ApolloClient/ApolloQueries";

class ShowLegalAudit extends React.Component {
  loading = false;

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      legal: null,
    };
  }

  componentDidMount() {
    this.getLegal(this.props.legalId);
  }

  async getLegal(id) {
    const query = await client.query({
      // 2
      query: QUERY_LEGAL_ENTITY, // 3
      variables: {
        // 4
        id: parseInt(id),
      },
      fetchPolicy: "cache-first",
    });

    this.setState({
      loading: false,
      legal: query.data?.legalEntity,
    });
  }

  render() {
    return this.state.loading ? (
      <span>legal={this.props.legalId}</span>
    ) : (
      <span>{this.state.legal?.name}</span>
    );
  }
}

export default ShowLegalAudit;
